// extracted by css-extract-rspack-plugin
module.exports =  {"highlighted":"NUK9t","recordsColumn":"F8Faf","vs_score":"d6mZa","score":"RB5HO","records":"Bzb6I"};